import axios from "axios";
import { API_URL } from "../constant";

const API_BASE_URL = API_URL || "https://staging.api.topcoinuk.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const itPortalService = {
  sendOtp: async () => {
    return api.post("/superadmin/it-portal/send-otp");
  },

  verifyOtp: async (otp) => {
    return api.post("/superadmin/it-portal/verify-otp", { otp });
  },

  getConfigs: async () => {
    return api.get("/superadmin/it-portal/configs");
  },

  updateConfigs: async (data) => {
    return api.put("/superadmin/it-portal/configs", data);
  },

  getUserTopCoins: async () => {
    return api.get("/superadmin/it-portal/user-topcoins");
  },

  createUserTopCoin: async (data) => {
    return api.post("/superadmin/it-portal/user-topcoins", data);
  },

  updateUserTopCoin: async (id, data) => {
    return api.put(`/superadmin/it-portal/user-topcoins/${id}`, data);
  },

  deleteUserTopCoin: async (id) => {
    return api.delete(`/superadmin/it-portal/user-topcoins/${id}`);
  },

  getVatConfigs: async () => {
    return api.get("/superadmin/it-portal/vat-configs");
  },

  createVatConfig: async (data) => {
    return api.post("/superadmin/it-portal/vat-configs", data);
  },

  updateVatConfig: async (id, data) => {
    return api.put(`/superadmin/it-portal/vat-configs/${id}`, data);
  },

  deleteVatConfig: async (id) => {
    return api.delete(`/superadmin/it-portal/vat-configs/${id}`);
  },
};

export default itPortalService;
